import { apiClient } from './authenticatedApiClient';
import { AppSingletonPromise } from './AppSingletonPromise';
import { IHypotheekResponse } from '@/model/IHypotheekResponse';

class AppHypothekenService {
  @AppSingletonPromise
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getHypotheken(force = false): Promise<IHypotheekResponse[]> {
    return apiClient.get<IHypotheekResponse[]>(`Hypotheken/`).then(response => {
      return response.data;
    });
  }
}

export const appHypothekenService = new AppHypothekenService();
